import { generate } from '../../../core/js/utils/componentUtils';
import template from 'category-applied-filter-count-mobile.j2';
import { dDom } from '../../../core/js/utils/renderUtils';

/**
 * Bootstrap the component onto the page
 * @param {object} store - The store
 * @param {object} overrides - The overrides object
 * @returns {undefined}
 */
export function init(store, overrides = {}) {
    const config = {
        children: [],
        templateLocation: '.dom-applied-filter-count',
        template: template,
        name: 'appliedFilterCountComponent',
        watch: 'category.queryString',
        renderType: dDom
    };

    return generate(config, store, overrides);
}
